import axios from 'axios'

const showAllCashOnDelivaryOrders = async () => {
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_API_BASE_URL}systemUsers/getAllCashOnDeliveryOrders`,
      {
        withCredentials: true,
        headers: {
          'Content-Type': 'application/json',
        },
      }
    )

    return response.data.data
  } catch (error) {}
}

export default showAllCashOnDelivaryOrders
